import React from "react";
import {
  Image,
  Pressable,
  StyleSheet,
  useWindowDimensions,
  Text,
  View
} from "react-native";
import IUserModel from "../../services/models/user";
import { CrownIcon, PersonIcon, PowerIcon, TrashIcon } from "../Icons";
import { colors } from "../Shared";

interface Props {
  user: Partial<IUserModel>;
  // onDelete: () => void;
  onAdmin: () => void;
  onActive: () => void;
}

export default function UserItemComponent({ user, onActive, onAdmin }: Props) {
  const window = useWindowDimensions();

  const { status, roll } = user;
  return (
    <View
      style={[styles.container, { width: window.width < 830 ? "100%" : "49%" }]}
    >
      {user.picture ? (
        <Image
          source={{ uri: user.picture }}
          style={{ width: 60, height: 60, borderRadius: 5 }}
        />
      ) : (
        <View
          style={{
            width: 60,
            height: 60,
            borderRadius: 5,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
          }}
        >
          <PersonIcon />
        </View>
      )}

      <View style={{ flex: 1, backgroundColor: 'transparent', flexDirection: 'column' }}>
          <Text style={{ marginVertical: 'auto', marginLeft: 5 }}>{user.name}</Text>
      </View>
      <Pressable style={styles.icons} onPress={onActive}>
        <PowerIcon color={status ? colors.bg.green : colors.bg.yellow} size={16} />
      </Pressable>
      <Pressable style={styles.icons} onPress={onAdmin}>
        <CrownIcon color={roll === 1 ? colors.bg.blue : 'black'} size={16} />
      </Pressable>
      {/* <Pressable style={styles.icons} onPress={onDelete}>
        <TrashIcon color={colors.bg.red} size={16} />
      </Pressable> */}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.bg.medium,
    flexDirection: "row",
    height: 70,
    top: -5,
    marginTop: 8,
    padding: 5,
    borderRadius: 5,
  },
  icons: {
    marginVertical: 'auto',
    marginHorizontal: 7
  },
});
